export default {
  state: {
    tags: null,
    currentTag: null,
  },
  getters: {
    TAGS: state => {
      return state.tags;
    },
    CURRENT_TAG: state => {
      return state.currentTag;
    },
  },
  mutations: {
    SET_TAGS: (state, payload) => {
      state.tags = payload;
    },
    SET_CURRENT_TAG: (state, payload) => {
      state.currentTag = payload;
    },
  },
  actions: {
    SET_TAGS: (context, tags) => {
      tags.map(tag => {
        tag.url_hash = `${tag.hash}${tag.password_hash !== '' ? `-${tag.password_hash}` : ''}`;
      });

      context.commit('SET_TAGS', tags);
    },
    SET_CURRENT_TAG: (context, tag) => {
      context.commit('SET_CURRENT_TAG', tag);
    },
  },
};